<template>
<div class="chapter">
<div class="inner_page">
<div class="element element-non-bodymatter element-container-single element-type-also-by element-without-heading" epub:type="z3998:published-works" id="also-by">
<div class="text" id="also-by-text">
<div class="inline-image inline-image-kind-photograph inline-image-size-full inline-image-flow-center inline-image-flow-within-text inline-image-aspect-tall block-height-not-mult-of-line-height inline-image-without-caption inline-image-begins-section">
<div class="inline-image-container">
<a class="link-contains-image" href="http://deals.bloodhoundbooks.com/join-mailing-list" target="_blank">
<img alt="" src="images/new-frontmatter-1.jpg"/>
</a>
</div>
</div>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// newsletter-sign-up.vue?765f0a71